export class Project {
    foremanId = null;
    requestedById = null;
    projectManagerId = null;
    projectName = '';
    subcontractorId = null;
    workOrderNumber = '';
    dispatchCompanyId = '';
    meetingLocation = null;
    jobLocation = null;
    notes = '';
    jobs = [];
    resources = [];
}

export const JobTypes = {
    Flagging: 1,
    DropoffPickup: 2,
};